import React from 'react';
import clsx from 'clsx';

export function Btn({ children, variant = 'primary', size = 'md', className, ...rest }) {
  const base =
    'inline-flex items-center justify-center gap-2 font-semibold uppercase tracking-wide2 text-xs transition-colors duration-75 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-accent text-white hover:bg-accentHover',
    secondary: 'bg-white text-ink border border-ink hover:bg-surface',
    ghost: 'bg-transparent text-ink hover:bg-surface',
    danger: 'bg-danger text-white hover:opacity-90',
  };
  const sizes = {
    sm: 'h-7 px-2.5',
    md: 'h-9 px-4',
    lg: 'h-11 px-6 text-sm',
  };
  return (
    <button className={clsx(base, variants[variant], sizes[size], className)} {...rest}>
      {children}
    </button>
  );
}

export function Input({ className, ...rest }) {
  return (
    <input
      className={clsx(
        'h-9 w-full px-3 bg-white border border-ink text-sm placeholder:text-muted focus:outline-none focus:ring-0 focus:border-accent',
        className
      )}
      {...rest}
    />
  );
}

export function Select({ className, children, ...rest }) {
  return (
    <select
      className={clsx(
        'h-9 w-full px-2 bg-white border border-ink text-sm focus:outline-none focus:border-accent',
        className
      )}
      {...rest}
    >
      {children}
    </select>
  );
}

export function Label({ children, className }) {
  return (
    <label
      className={clsx(
        'block text-[10px] font-bold uppercase tracking-wide2 text-muted mb-1.5',
        className
      )}
    >
      {children}
    </label>
  );
}

export function PageHeader({ title, subtitle, children, testid }) {
  return (
    <div data-testid={testid} className="px-8 py-6 border-b border-ink/90 flex items-end justify-between gap-4">
      <div>
        <div className="text-[10px] font-bold uppercase tracking-wide2 text-muted">
          Administracion
        </div>
        <h1 className="text-3xl font-semibold tracking-tight mt-1">{title}</h1>
        {subtitle && <p className="text-sm text-muted mt-1">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-2">{children}</div>
    </div>
  );
}

export function Card({ children, className, testid }) {
  return (
    <div
      data-testid={testid}
      className={clsx('border border-ink/90 bg-white', className)}
    >
      {children}
    </div>
  );
}
